<template>
  <div>
    <p style="margin-bottom: 5px">
      Har du skyddad folkbokföring eller sekretessmarkering? Använd endast våra
      formulär och bjud in övriga parter via verktyget. Dela inga personliga
      uppgifter utanför systemet.
    </p>
    <p>
      Behöver du hjälp med er ansökan? Kontakta oss på
      <a :href="`mailto:${supportAddress}`" class="mail-to" target="_blank">{{
        supportAddress
      }}</a
      >.
    </p>
  </div>
</template>

<script>
export default {
  props: {
    supportAddress: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
div {
  margin-bottom: 2rem;
}
</style>
